export default __webpack_public_path__ + "static/media/accept.6e7354a9.svg";